import React, { Fragment } from 'react';
import { Divider, Grid } from '@mui/material';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import ReceiptItem from 'components/common/receipt/receipt_item';
import CustomTaxReceiptItem from 'components/common/receipt/custom_tax_receipt_item';
import DiscountReceiptItems from 'components/common/receipt/discount_receipt_items';
import { orderSummaryStyles } from 'components/pages/checkout/order_summary';
import { subtitleStrings } from 'utilities/financing_strings';
import { useTranslation } from 'react-i18next';

const InstallmentReceipt = () => {
  const classes = orderSummaryStyles();
  const { t } = useTranslation();
  const { orderData } = useCheckoutFlow();

  const summary = orderData.installment_summary;

  if (Object.entries(summary).length === 0) {
    return null;
  }

  const n = summary.number_payment_periods;
  const financedAmount = summary.financed_amount;

  return (
    <>
      <Grid className={classes.orderSummary}>
        <h3>{t('checkout.receipt.label.installmentPlanTitle', { n })}</h3>
        <ReceiptItem
          label={orderData.subtotal.label}
          cost={orderData.subtotal.amount}
          currency={orderData.subtotal.currency}
        />
        <CustomTaxReceiptItem orderData={orderData} taxType="line_item" />
        <DiscountReceiptItems orderData={orderData} discountType="line_item" />
        <Divider sx={{ my: 1 }} />
        {subtitleStrings(summary).map((s, idx) => (
          <Fragment key={`offer-subtitle-${idx}`}>
            <div className="paragraph-20">{s}</div>
          </Fragment>
        ))}
        <Divider sx={{ my: 1 }} />
        <ReceiptItem
          label="checkout.receipt.label.installmentPlanTotal"
          cost={financedAmount.amount}
          currency={financedAmount.currency_code}
          emphasize
        />
      </Grid>
      <Grid className={classes.orderSummary}>
        <h3>{t('checkout.receipt.label.hardwarePaidToday')}</h3>
        <ReceiptItem
          label="checkout.receipt.label.deposit"
          cost={orderData.installment_summary.final_payment_amount.amount}
          currency={
            orderData.installment_summary.final_payment_amount.currency_code
          }
        />
        {orderData.shipping.amount > 0 && (
          <>
            <Divider sx={{ my: 1 }} />
            <ReceiptItem
              label={orderData.shipping.label}
              cost={orderData.shipping.amount}
              currency={orderData.shipping.currency}
              isShipping={true}
            />
            <DiscountReceiptItems
              orderData={orderData}
              discountType="shipment"
            />
            <CustomTaxReceiptItem orderData={orderData} taxType="shipment" />
          </>
        )}
        <Divider sx={{ my: 1 }} />
        <ReceiptItem
          label="checkout.receipt.label.dueToday"
          cost={orderData.payment_due.amount}
          currency={orderData.payment_due.currency}
          emphasize
        />
      </Grid>
    </>
  );
};

export default InstallmentReceipt;
